export default __webpack_public_path__ + "static/media/permissions-not-selected.3bbdba74.svg";